import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';

/*
  Generated class for the EmailProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class EmailProvider {

  url = "http://retirement-api.enacment-production.com/email";

  constructor(public http: HttpClient) {
    ////console.log('Hello EmailProvider Provider');
  }

  sendEmail(body: any): Observable<object> {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };
    return this.http.post(this.url, body, httpOptions);
  }

}



// WEBPACK FOOTER //
// ./src/providers/email/email.ts